import DateObject from 'react-date-object';
import gregorian from 'react-date-object/calendars/gregorian';
import persian from 'react-date-object/calendars/persian';
import persian_fa from 'react-date-object/locales/persian_fa';

const FA_DIGITS = '۰۱۲۳۴۵۶۷۸۹';

export const toPersianDigits = (value) =>
  String(value ?? '').replace(/\d/g, (d) => FA_DIGITS[Number(d)]);

// Users can reasonably type ۱۴۰۵-۰۴ into a form; the API only accepts ASCII.
export const toLatinDigits = (value) =>
  String(value ?? '')
    .replace(/[۰-۹]/g, (d) => String(FA_DIGITS.indexOf(d)))
    .replace(/[٠-٩]/g, (d) => String('٠١٢٣٤٥٦٧٨٩'.indexOf(d)));

// The API speaks Gregorian ISO throughout. Parsing via a real Date keeps the
// timezone handling honest: server timestamps are UTC and are shown in the
// viewer's local time, which is what an operator in Tehran expects to see.
const toDateObject = (isoValue) => {
  const parsed = new Date(isoValue);
  if (Number.isNaN(parsed.getTime())) return null;
  return new DateObject({ date: parsed, calendar: gregorian }).convert(persian, persian_fa);
};

export const formatJalaliDate = (isoValue) => {
  if (!isoValue) return '—';
  const d = toDateObject(isoValue);
  return d ? d.format('YYYY/MM/DD') : '—';
};

export const formatJalaliDateTime = (isoValue) => {
  if (!isoValue) return '—';
  const d = toDateObject(isoValue);
  return d ? d.format('YYYY/MM/DD HH:mm') : '—';
};

// Periods are already Jalali -- they are the filename ("1405-03"). Only the
// digits need localising, and the separator becomes "/" to read as a date.
export const formatPeriod = (period) =>
  (period ? toPersianDigits(String(period).replace('-', '/')) : '—');
